module.exports = __webpack_public_path__ + "img/Sicherheitstor.a0f3f891.webp";